import React, { useEffect, useRef } from 'react'

export default function SuccessMessage(prop) {
    const message = prop.message;
    const focusRef = useRef();
    useEffect(()=>{
        focusRef.current.focus();
    }, []);
    return (
        <>
            <div className="success-message" ref={focusRef} tabIndex={0} aria-label={message}>
                <span>{message}</span>
            </div>
        </>
    );
};
